import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: goals.BadgeCriteria.
export default class BadgeCriteria extends Fragment {
  declare [Type]: 'goals/badge-criteria';

  // A narrative of what is needed to earn the badge.
  @attr('string', { defaultValue: '' })
  declare narrative: string;
}
